import { render } from "./PrivacyPolicyComponent.vue?vue&type=template&id=b3c81274&scoped=true"
import script from "./PrivacyPolicyComponent.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyComponent.vue?vue&type=script&lang=js"

import "./PrivacyPolicyComponent.vue?vue&type=style&index=0&id=b3c81274&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c81274"]])

export default __exports__